import { observable } from 'mobx';
import mobx from 'mobx';
import axios from 'axios';
import { getPortfolio,
  getPortfolioSlots,
  getPortfolioKiosks
} from '../data/portfolio';

var global = function () { };
const GH_ENDPOINT = {
  JOGRUBER: 'https://github-contributions-api.jogruber.de/v4/',
  ORENDER: 'https://gh-graph-scraper.onrender.com/api/scrape?username=',
  VERCEL: 'https://gh-graph-scraper.vercel.app/api/scrape?username=',
  LOCAL: 'http://localhost:3000/api/scrape?username='
}

global.store = observable({
  TOGGLE_SIDEBAR: false,
  repos: [],
  isFetching: true,
  portfolios: [],
  portfolioSlots: [],
  portfolioKiosks: [],
  githubContributions: {}
})


global.init = function () {
  global.fetchRepos();
  global.fetchPortfolio();
  global.fetchGithubContributions();
}

global.toggleSidebar = function () {
  global.store.TOGGLE_SIDEBAR = !global.store.TOGGLE_SIDEBAR;
}
global.closeSidebar = function () {
  global.store.TOGGLE_SIDEBAR = false;
}
global.openSidebar = function () {
  global.store.TOGGLE_SIDEBAR = true;
}

global.fetchPortfolio = function () {
  global.store.portfolios.replace(getPortfolio());
  global.store.portfolioSlots.replace(getPortfolioSlots());
  global.store.portfolioKiosks.replace(getPortfolioKiosks());
}
global.fetchRepos = function () {
  axios.get('https://api.github.com/users/codingmalkio/repos')
    .then(function (response) {
      global.store.isFetching = false;
      global.store.repos.replace(response.data);
    })
}

global.fetchGithubContributions = function () {
  axios.get(GH_ENDPOINT.VERCEL + 'codingmalkio')
    .then(function (response) {
      if (response.data && !response.data.error) {
        let _contrib = {};
        response.data.contributions.forEach(function (contrib) {
          _contrib[contrib.date] = contrib.count;
        });
        global.store.githubContributions = _contrib;
      }
    });
}

window.global = global;
window.store = global.store;
export default global;



// WEBPACK FOOTER //
// ./src/global/index.js